import { useContext } from "react";
import { UNSAFE_DataRouterStateContext } from "react-router";
import type { NavSessionUser } from "~/lib/nav-session";

/**
 * The query that keeps a signed-in member on the public home (T634): `/es` sends her to her
 * space unless the link carries `?public=1`. The chrome passes its `sessionUser` prop; a page
 * link (the waitlist buttons on Home, Método, FAQ and the auto-test result — T872 N2, Astra's
 * second audit: they sent a member to `/es/panel`) reads the root loader's session here.
 * `undefined` for a guest, so her links stay as they were. Read from the router's state
 * context, not `useRouteLoaderData`, so a page rendered outside a data router (a view under
 * test) reads a guest instead of throwing — as `boundary-route-id.ts` does.
 */
export function usePublicHomeSearch(): string | undefined {
  const root = useContext(UNSAFE_DataRouterStateContext)?.loaderData?.root as
    | { sessionUser?: NavSessionUser | null }
    | undefined;
  return root?.sessionUser ? "?public=1" : undefined;
}
